export function PageMeta() {
  return (
    <>
      <meta
        name="description"
        content="Céges pénzügyeid, ahogy mindig is szeretted volna! Próbáld ki 30 napig ingyen!"
      />
      {process.env.NODE_ENV === 'production' && <meta name="robots" content="index, follow" />}
    </>
  )
}

export function PageNoIndexMeta() {
  return <meta name="robots" content="noindex, nofollow" />
}
